module.exports = require("object-assign");


//////////////////
// WEBPACK FOOTER
// external "object-assign"
// module id = 48
// module chunks = 0